<template>
  <div>
    <h3>Dados de Acesso</h3>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="user.name"
        placeholder="Nome"
        :state="validateState('name')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Email:">
      <b-form-input
        v-model="user.email"
        placeholder="Email"
        disabled
      ></b-form-input>
    </b-form-group>

    <b-row>
      <b-col>
        <b-form-group label="CPF:">
          <b-form-input
            v-model="cpf"
            placeholder="___.___.___-__"
            @keypress="isNumber($event)"
            maxlength="11"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="RG:">
          <b-form-input
            v-model="user.pessoa_fisica.rg"
            placeholder="RG"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <h3>Endereço</h3>
    <Endereco v-model="user.pessoa_fisica.endereco" ref="endereco" />
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";
import {
  required,
  minLength,
  email,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import Endereco from "@/components/Form/Endereco.vue";

export default {
  mixins: [validationMixin],
  components: { Endereco },
  data: () => ({}),
  validations: {
    user: {
      name: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      password: {
        required: requiredIf(function (user) {
          return user.id ? false : true;
        }),
        minLength: minLength(6),
      },
      password_confirmation: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    cpf: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 11);
        this.user.pessoa_fisica.cpf = value;
      },
      get() {
        let cpf = "";
        if (this.user.pessoa_fisica.cpf) {
          cpf = this.user.pessoa_fisica.cpf.replace(
            /^(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
          );
        }

        return cpf;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.user.$touch();
      return !this.$v.user.$anyError && this.$refs.endereco.isValid();
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  watch: {
    "user.name": {
      deep: true,
      handler: function (value) {
        this.user.pessoa_fisica.nome = value;
      },
    },
  },
  async created() {},
};
</script>

<style></style>
